<template>
	<v-main :id="id" :role="role" v-bind="$attrs" v-on="$listeners">
		<slot/>
	</v-main>
</template>

<script>
export default {
	name: 'KMain',
	inheritAttrs: false,
	props: {
		id: {
			type: String,
			default: undefined
		},
		role: {
			type: String,
			default: undefined
		}
	}
}
</script>
